<template>

    <section v-if="quoteRequest && quoteRequest.company">
        <!-- Scope of works -->
        <div class="container  margin-top-30">

            <div class="columns">
                <div class="column is-two-thirds">
                    <h3 class="title is-4">Job Details</h3>
                    <p style="flex: 2; background: white; padding: 1rem;" v-html="quoteRequest.scopeDescription"></p>
                    <p style="flex: 2; padding: 1rem;">This job contains <strong>{{itemCount}}</strong> item<span v-if="itemCount !== 1">s</span> that require<span v-if="quoteRequest.items.length === 1">s</span> a cost from you. <span v-if="quoteRequest.items.length !== 1">They</span><br><span v-if="quoteRequest.items.length === 1">It</span> will be shown on the next step if you choose to quote.</p>
                    <p class="notification">Any questions? <a class="" v-on:click="$emit('toggleMessagePane', true)">Send a message</a></p><br><br>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div v-if="hasAttachments" class="">
                        <h3 class="title is-4">Files &amp; Attachments</h3>
                        <div v-for="(attachment, index) in quoteRequest.attachments" v-bind:key="index"
                             class="level level--attachment-item-row  _is-mobile">
                            <div class="level-left">
                                <div class="level-item  has-text-left _is-hidden-mobile" v-if="!folderCheckGuid(attachment.folder)"
                                     style="min-width: 100px; justify-content: flex-start">
                                    <i class="far fa-folder" aria-hidden="true"></i>&nbsp;
                                    {{getFolderName(attachment.folder)}}&nbsp;
                                    <i class="fa fa-angle-right"></i>
                                </div>
                                <div class="level-item" style="justify-content: flex-start">
                                    <a v-bind:href="attachment.storageUrl"
                                       data-fancybox="'images'" v-bind:data-caption="`${attachment.storageFileName}`">{{attachment.fileName}} (Click to view)</a>
                                </div>
                            </div>
                            <div class="level-right" >
                                <div class="level-item" style="justify-content: flex-end">
                                    <a class="btn-attachment-download has-text-dark" @click="downloadFile(attachment)"
                                       target="_blank"><i class="fas fa-cloud-download-alt"></i>&nbsp;&nbsp;Download</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
import axios from 'axios'

export default {
  name: 'section-scope-basic',
  components: {},
  props: ['quoteRequest', 'dateDeadline', 'reopenVisible', 'dateSubmitted', 'token', 'step', 'stepReached', 'statusMenu'],
  data () {
    return {
      instructions: true
    }
  },
  methods: {
    hideInstructions () {
      this.instructions = false
    },
    downloadFile (attachment) {
      const AuthStr = `Bearer ${this.$store.state.token}`
      axios.get(`${attachment.url}`, {headers: {Authorization: AuthStr}})
        .then(response => {
          // If request is good...
          let url = `${window.APP_CONFIG.apiServiceUrl}metadata/storage/download?token=${encodeURIComponent(response.data)}`
          window.location.href = url
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    getFolderName (folder) {
      let names = {
        'docs': 'Document',
        'uploads': 'Attachment',
        'plans': 'Plan',
        'takeoffs': 'Takeoff'
      }
      return names[folder.toLowerCase()] || folder
    },
    folderCheckGuid (folder) {
      let r = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)
      return r.test(folder)
    }
  },
  computed: {
    //
    hasAttachments () {
      return this.quoteRequest.attachments.length
    },
    itemCount () {
      return this.quoteRequest.items.reduce((acc, cur) => {
        if (!cur.isRecipe) {
          return acc + 1
        } else {
          return acc + cur.recipeItems.length
        }
      }, 0)
    }
  }
}
</script>
